// src/components/Footer.js
import React, { useState } from 'react';
import TermsConditions from './TermsConditions';
import '../styles/footer.css';

function Footer() {
  const [showTerms, setShowTerms] = useState(false);

  const handleTermsClick = () => {
    setShowTerms(true);
  };

  const handleCloseTerms = () => {
    setShowTerms(false);
  };

  if (showTerms) {
    return (
      <div className="terms-backdrop" onClick={handleCloseTerms}>
        <div className="terms-modal" onClick={e => e.stopPropagation()}>
          <div className="terms-modal-header">
            <div className="terms-modal-title">Условия за Ползване и Правна Рамка</div>
            <button className="modal-close-btn" onClick={handleCloseTerms} aria-label="Затвори">
              ×
            </button>
          </div>
          <div className="terms-modal-body">
            <TermsConditions />
          </div>
        </div>
      </div>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Контакти</h3>
          <div className="contact-info">
            <div className="contact-item">
              <span className="material-icons">phone</span>
              <span>+359 87 677 5346</span>
            </div>
            <div className="contact-item">
              <span className="material-icons">email</span>
              <span>radipenchev5@gmail.com</span>
            </div>
            <div className="contact-item">
              <span className="material-icons">location_on</span>
              <span>Враца, България</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3>Услуги</h3>
          <ul className="footer-links">
            <li>Създаване на сватбен уебсайт</li>
            <li>Персонализиране на шаблони</li>
            <li>Техническа поддръжка</li>
            <li>Премиум услуги</li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Полезно</h3>
          <ul className="footer-links">
            <li>
              <button 
                className="terms-link" 
                onClick={handleTermsClick}
              >
                Условия за ползване
              </button>
            </li>
            <li>Политика за поверителност</li>
            <li>Често задавани въпроси</li>
            <li>Поддръжка</li>
          </ul>
        </div>

        {/* Social links section removed */}
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; 2026 Nashata Svatba. Всички права запазени.</p>
          <p className="disclaimer">
            Потребителите носят пълна отговорност за качественото от тях съдържание. 
            Ние не поемаме отговорност за потребителско съдържание.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
